import PropTypes from 'prop-types';
import {FmlxIcon} from 'fmlx-common-ui';
import {Size} from 'constants/UIComponentEnum';
import './PipettingProfile.scss';

function PipettingProfileExpanderButton({isExpanded, onClick}) {
  return (
    <div
      className={`pipetting-profile-expander pipetting-profile-expanded-${Boolean(isExpanded)}`}
      role="presentation"
      onClick={(e) => {
        onClick(!isExpanded);
        e.stopPropagation();
      }}
    >
      <span className="pipetting-profile-expander-name">{isExpanded ? 'Show less' : 'Show more'}</span>
      <FmlxIcon name={`${isExpanded ? 'ArrowUpS' : 'ArrowDownS'}`} size={Size.XS} />
    </div>
  );
}

PipettingProfileExpanderButton.propTypes = {
  isExpanded: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default PipettingProfileExpanderButton;
